export default __webpack_public_path__ + "static/media/instagram.afe82018.svg";